import React from "react";
import { ChatBubbleIcon, UsersIcon } from "../Dashboard/icons";
import { ClockIcon } from "../Auth/onboarding/icons";
import { TargetIcon, HeartIcon } from "./icons";

const TrendIcon = ({ down }) => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.4">
    {down ? (
      <>
        <path d="M4 8l6 6 4-4 6 7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 7h5v5" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ) : (
      <>
        <path d="M4 16l6-6 4 4 6-7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 7h5v5" strokeLinecap="round" strokeLinejoin="round" />
      </>
    )}
  </svg>
);

const stats = [
  {
    icon: <ChatBubbleIcon />,
    variant: "indigo",
    label: "Total conversations",
    value: "1,248",
    delta: "18.6%",
    down: false,
  },
  {
    icon: <UsersIcon />,
    variant: "green",
    label: "Leads captured",
    value: "123",
    delta: "22.4%",
    down: false,
  },
  {
    icon: <TargetIcon />,
    variant: "amber",
    label: "Conversion rate",
    value: "9.9%",
    delta: "8.1%",
    down: false,
  },
  {
    icon: <ClockIcon />,
    variant: "blue",
    label: "Avg. response time",
    value: "3.2s",
    delta: "0.6s",
    down: true,
  },
  {
    icon: <HeartIcon />,
    variant: "rose",
    label: "Satisfaction rate",
    value: "92%",
    delta: "5.3%",
    down: false,
  },
];

export default function StatCards() {
  return (
    <div className="an-stats">
      {stats.map((stat) => (
        <div className="dash-stat-card" key={stat.label}>
          <span className={`dash-stat-icon dash-stat-icon--${stat.variant}`}>{stat.icon}</span>
          <span className="dash-stat-label">{stat.label}</span>
          <span className="dash-stat-value">{stat.value}</span>
          <span className="dash-stat-delta">
            <TrendIcon down={stat.down} />
            {stat.delta}
            <span className="dash-stat-compare">vs May 7 &ndash; May 13</span>
          </span>
        </div>
      ))}
    </div>
  );
}
